<template>
  <div id="NotFound">

    <div class="container">
      <div class="app_header">
        <Header />
      </div>
      <div class="app_main">

        <div class="not_found">
          <h1>404 - Page Not Found</h1>
          <p>The page you are looking for does not exist.</p>
          <el-button type="primary" size="mini" @click="goHome">Go Home</el-button>
        </div>

      </div>
      <div class="app_footer">
        <Footer />
      </div>
    </div>
    
  </div>
</template>
<script>
import Header from '../components/Header.vue';
export default {
  name: 'NotFound',
  components: {
    Header
  },
  data() {
    return {
    }
  },
  methods: {
    goHome() {
      this.$router.push('/');
    }
  }
}
</script>
<style lang="less" scoped>
.not_found{
  text-align: center;
  padding: 160px 0 60px;
  font-size: 12px;
  h1{
    font-size: 20px;
    line-height: 40px;
    font-weight: 600;
  }
  p{
    margin-bottom: 30px;
    font-weight: 400;
  }
  .el-button{
    text-transform: uppercase;
  }
}
</style>